import { defineStore } from "pinia";
import { StoreModule } from "@/constants/store.ts";
import { axiosInstance } from "@/plugins/https.ts";
import api from "@/_helpers/api.ts";

type ChameleonConfig = {
  userId: string;
  uid_hash: string;
};

type AppConfigState = {
  chameleon: ChameleonConfig | null;
};

const defaultState: AppConfigState = {
  chameleon: null,
};

export const useAppConfigStore = defineStore(StoreModule.APP_CONFIG, {
  state: (): AppConfigState => ({ ...defaultState }),
  actions: {
    async getChameleonIdentity(): Promise<ChameleonConfig | null> {
      try {
        const { data } = await axiosInstance.request(api.chameleonIdentity);
        this.chameleon = data ?? null;
        return data;
      } catch (e) {
        console.error(e);
        return null;
      }
    },
  },
});
